import has from 'lodash/has';
import { decode } from 'html-entities';
import {
    setOrganizerMarketingOptInAction,
    setOrganizerNameAndLogoAction,
    setOrganizerUrlAndFollowersAction,
} from '../../organizer';
import { getOrganizer } from '../../../api/organization';

export const getOrganizerData = () => async (dispatch, getState) => {
    const {
        app: { event },
    } = getState();

    if (has(event, 'organizer_id')) {
        const organizerData = await getOrganizer(event['organizer_id']);

        dispatch(
            setOrganizerNameAndLogoAction({
                logoUrl: organizerData.response.logo?.url ?? null,
                name: decode(organizerData.response.name),
            }),
        );

        dispatch(
            setOrganizerUrlAndFollowersAction({
                url: organizerData.response.url,
                followedByYou:
                    organizerData.response.follow_status?.followed_by_you ??
                    false,
                numFollowers:
                    organizerData.response.follow_status?.num_followers ?? 0,
            }),
        );

        return dispatch(
            setOrganizerMarketingOptInAction(
                !organizerData.response.disable_marketing_opt_in,
            ),
        );
    }

    return dispatch(setOrganizerMarketingOptInAction(false));
};
